const common = {
  no_data_title: 'No hay datos',
  no_data_description: 'No hay registros para mostrar.',
  loading: 'Cargando...',
  error: 'Ha ocurrido un error',
  success: 'Operacion completada con exito',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  save: 'Guardar',
  delete: 'Eliminar',
  edit: 'Editar',
  create: 'Crear',
  search: 'Buscar',
  filter: 'Filtrar',
  export: 'Exportar',
  help: 'Ayuda',
  filters: {
    label: 'Filtros',
    show: 'Mostrar filtros',
    hide: 'Ocultar filtros',
  },
  clear: 'Limpiar',
  yes: 'Si',
  no: 'No',
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
    pending: 'Pendiente',
  },
  notifications: {
    session_extended_success: 'Sesion extendida correctamente',
    session_expired: 'Tu sesion ha expirado. Por favor, inicia sesion de nuevo.',
    connection_error: 'Error de conexion. Por favor, comprueba tu conexion a internet.',
    server_error: 'Error del servidor. Por favor, intentalo de nuevo mas tarde.',
    save_success: 'Datos guardados correctamente',
    save_error: 'Error al guardar los datos',
    delete_success: 'Elemento eliminado correctamente',
    delete_error: 'Error al eliminar el elemento',
  },
  validation: {
    required: 'Este campo es obligatorio',
    email: 'Por favor, introduce un email valido',
    minLength: 'Debe tener al menos %{min} caracteres',
    maxLength: 'No puede tener mas de %{max} caracteres',
    number: 'Debe ser un numero valido',
    positive: 'Debe ser un numero positivo',
    unique: 'Este valor ya existe',
  },
};

export default common;
